export const primaryColor = '#0c1b40';
export const secondaryColor = '#D3D3D3';
export const textColor = 'rgb(68 119 183)';
export const secondaryTextColor = "#000000B3"
export const font = "Raleway"
export const backgroundColor = "#F0F2F7"
export const buttonColor = "rgb(184 190 255)"
export const headerColor = "white"
export const footerColor = "rgb(201 214 223)"